import { SmsTemplateStory } from '@aclass/admin/storage/actions';
import {
    INITIAL_SMS_TEMPLATE_STATE,
    ISmsTemplateModuleState,
} from '@aclass/admin/storage/states';
import { Action } from '@aclass/core/storage/action';
import { TypedState } from '@aclass/core/storage/states/module.state';
import { fromJS, List, Map } from 'immutable';

export const smsTemplateModuleReducer = (state: TypedState<ISmsTemplateModuleState> = INITIAL_SMS_TEMPLATE_STATE, action: Action) => {
    const { type, payload } = action;
    switch (type) {
        case SmsTemplateStory.SEARCH_PAGE_UPDATE_INIT_STATE:
            return state.update('searchPageInitialized', () => payload);
        case SmsTemplateStory.SEARCH_PAGE_UPDATE_COLLAPSED:
            return state.update('searchPageCollapsed', () => payload);
        case SmsTemplateStory.SEARCH_PAGE_UPDATE_FORM:
            return state.update('searchPageForm', () => fromJS(payload));
        case SmsTemplateStory.SEARCH_PAGE_UPDATE_SEARCH_LOCK:
            return state.update('searchPageLock', () => payload);
        case SmsTemplateStory.SEARCH_PAGE_UPDATE_ORDER:
            return state.update('searchPageOrder', () => Map(payload));
        case SmsTemplateStory.SEARCH_PAGE_IMPORT_RECORDS:
            return state.update('searchPageResults', () => List(payload));
        case SmsTemplateStory.SEARCH_PAGE_UPDATE_PAGINATION:
            return state.update('searchPagePagination', () => Map(payload));
        case SmsTemplateStory.CREATE_PAGE_UPDATE_SAVE_LOCK:
            return state.update('createPageSaveLock', () => payload);
        case SmsTemplateStory.EDIT_PAGE_UPDATE_FORM:
            return state.update('editPageForm', () => fromJS(payload));
        case SmsTemplateStory.EDIT_PAGE_UPDATE_ID:
            return state.update('editPageRecordId', () => payload);
        case SmsTemplateStory.EDIT_PAGE_UPDATE_ACTIVE_ID:
            return state.update('editPageActiveId', () => payload);
        case SmsTemplateStory.EDIT_PAGE_UPDATE_BRAND:
            return state.update('editPageBrand', () => payload);
        case SmsTemplateStory.EDIT_PAGE_UPDATE_LOCALE:
            return state.update('editPageLocale', () => payload);
        case SmsTemplateStory.EDIT_PAGE_UPDATE_SAVE_LOCK:
            return state.update('editPageSaveLock', () => payload);
        default:
            return state;
    }
};
